import React, { useContext, useEffect, useState } from "react";

import { GlobalContext } from "@/contexts";
import {
  AdvertisingInteractionOutro,
  QuestionOrAdvertisingOutro,
} from "@/service/Model";
import TrackingService from "@/service/Tracking";
import { inIframe } from "@/utils/getters";

import { AdSlot, Center } from "./styles";

export type AdvertisementProps = {
  outro: AdvertisingInteractionOutro | QuestionOrAdvertisingOutro;
};

const isInIframe = inIframe();

export const Advertisement: React.FC<AdvertisementProps> = (
  props: AdvertisementProps
): React.JSX.Element => {
  const { outro } = props;
  const adSlot = outro.advertisingAdSlot ?? "";
  const height = Number(outro.advertisingHeight);
  const width = Number(outro.advertisingWidth);

  const globalContext = useContext(GlobalContext);
  const isPreview = globalContext.preview;

  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    // Hint: Only one size (width, height) can be configured in la-interactive-admin-web, there could be more if required.
    window.adSSetup = {
      adSlotSizes: {
        [adSlot]: [
          {
            minWidth: 1,
            sizes: [[width, height]],
          },
        ],
      },
    };

    if (isInIframe) {
      // This adLib extension needs some preloaded scripts on the parent page.
      loadCorsFrameAdLib();
    }
  }, []);

  useEffect(() => {
    if (isPreview || !loaded) {
      return;
    }

    try {
      const adLibEvent = new CustomEvent("renderAd", { detail: adSlot });
      window.dispatchEvent(adLibEvent);
      TrackingService.getInstance().trackOnOutroImpression();
    } catch (e) {
      console.error("Could not dispatch renderAd adLibEvent", e);
    }
  }, [loaded]);

  const loadCorsFrameAdLib = () => {
    const script = document.createElement("script");
    script.src = "https://www.asadcdn.com/adlib/extensions/corsFrameAdLib.js";
    script.onload = () => setLoaded(true);
    document.body.appendChild(script);
  };

  if (
    globalContext.tealiumConfig?.is_premium_user ||
    !adSlot ||
    !width ||
    !height
  ) {
    return <></>;
  }

  return (
    <Center>
      <AdSlot
        isPreview={isPreview}
        forcePreview={!isPreview && !isInIframe}
        id={adSlot}
        style={{ width, height }}
        data-qa="outro.advertising.adSlot"
      />
    </Center>
  );
};
